import React, { Component } from "react";

const DataIcon = ({ width, height, fill,style, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 17"
      fill="none"
      style={style}
      {...rest}
    >
      <path
        d="M10.6284 5.31116V2.83105C9.6418 2.07184 8.5882 1.40393 7.48061 0.835565C6.78767 0.486556 6.06202 0.206682 5.31419 0C4.56637 0.206692 3.84073 0.486565 3.1478 0.835565C2.04019 1.40389 0.986586 2.07181 0 2.83105V5.31116C0.977666 4.5016 2.03191 3.78926 3.1478 3.18427C3.5276 2.97842 3.89373 2.80446 4.25151 2.65254V14.8754H6.3784V2.65254C6.73618 2.80446 7.10459 2.97766 7.48211 3.18427C8.59798 3.7893 9.65224 4.50163 10.6299 5.31116"
        fill={fill}
      />
      <path
        d="M10.6306 11.6888V14.1689C11.6172 14.9281 12.6709 15.596 13.7785 16.1644C14.4714 16.5134 15.197 16.7932 15.9449 16.9999C16.6927 16.7933 17.4183 16.5134 18.1113 16.1644C19.2189 15.5961 20.2725 14.9282 21.2591 14.1689V11.6888C20.2814 12.4984 19.2272 13.2107 18.1113 13.8157C17.7315 14.0215 17.3653 14.1955 17.0076 14.3474V2.12305H14.8807V14.3459C14.5229 14.194 14.1545 14.0208 13.7769 13.8142C12.6611 13.2091 11.6068 12.4968 10.6291 11.6873"
        fill={fill}
      />
    </svg>
  );
};

DataIcon.defaultProps = {
  fill: "#8D0053",
  width: 25,
  height: 25,
};

export default DataIcon;
